import { Stack } from "@mui/material";
import useLangChanger from "../hooks/useLangs";
import he from '../assets/svgGame/he.svg'
import en from '../assets/svgGame/en.svg'

export default function LanguageSwitcher() {
  const { currLang, changeLanguage } = useLangChanger();

  return (
    <Stack
      position={'absolute'}
      top={5}
      right={5}
      spacing={.5}
      zIndex={50}
    >
      {/* {currLang != 'en' */}
      <img
        src={en}
        onClick={() => changeLanguage({ code: 'en', isRtl: false })}
      />

      <img
        src={he}
        onClick={() => changeLanguage({ code: 'he', isRtl: true })}
      />
      {/* } */}
    </Stack>
  );
};